import { SxProps, Theme } from '@mui/material'

export function concatToSXProp(
  propsStyles?: SxProps<Theme>,
  ...componentStyles: SxProps[]
): SxProps<Theme> {
  return [...(Array.isArray(propsStyles) ? propsStyles : [propsStyles]), ...componentStyles]
}
